import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Phone18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_651)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.41128 1.52181L6.41222 1.52415L8.00219 5.52409C8.17667 5.96297 8.07327 6.49048 7.74594 6.83096L7.74032 6.83681L6.32693 8.27553C6.49991 9.26365 7.01546 9.97419 7.66482 10.7018C8.23745 11.3434 9.04105 11.7658 9.89107 11.8753C10.3677 11.4006 10.8464 10.9279 11.3177 10.448C11.6609 10.1181 12.1879 10.0076 12.6323 10.1842L16.6346 11.7752C17.2626 12.0273 17.5906 12.825 17.2888 13.4411C16.4643 15.1242 15.0188 16.4475 13.2785 17.1376C9.9661 18.2026 6.41295 16.4091 4.11929 14.0658C1.94033 11.8397 -0.175593 8.07938 1.0559 4.90028C1.73693 3.14221 3.0527 1.70358 4.74316 0.868729C5.35914 0.564529 6.15915 0.893695 6.41128 1.52181ZM5.13016 2.35963L6.54333 5.91478L4.75588 7.73434C4.89925 9.2572 5.43441 10.6569 6.56894 11.7264C7.47845 12.7317 8.79004 13.3459 10.145 13.4006C11.0186 13.0592 11.5898 12.3076 12.2448 11.6444L15.7979 13.0567C15.127 14.2645 14.0597 15.2081 12.7722 15.7247C10.0574 16.5817 7.04889 14.9144 5.19123 13.0166C3.33538 11.1206 1.61851 8.14997 2.46346 5.41944C2.97312 4.11932 3.91702 3.03926 5.13016 2.35963Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_651'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Phone18.displayName = 'Phone18';
export default Phone18;
